"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSetAdvancedVideoSettings = exports.requestGetAdvancedVideoSettings = void 0;
var _globalStates = require("../../../globalstates/globalStates");
var _msgTypes = require("./msgTypes");
var requestGetAdvancedVideoSettings = exports.requestGetAdvancedVideoSettings = function requestGetAdvancedVideoSettings() {
  (0, _globalStates.getGlobalStates)().eventBus.sendMsg(_msgTypes.REQUEST_GET_VIDEO_SETTINGS);
};
var requestSetAdvancedVideoSettings = exports.requestSetAdvancedVideoSettings = function requestSetAdvancedVideoSettings(videoSettings) {
  (0, _globalStates.getGlobalStates)().eventBus.sendMsg(_msgTypes.REQUEST_SET_VIDEO_SETTINGS, videoSettings);
};